import React, { Component } from "react";
import {
  Card,
  Button,
  Modal,
  Input,
  TextArea,
  Grid,
  GridItem
} from "@sainsburys-tech/fable";
import ButtonGroup from "../ButtonGroup";
import PropTypes from "prop-types";
import * as ErrorRegistry from "../../model/errors/apiErrorRegistry";
import LoadingWrapper from "../LoadingWrapper";

const renderError = (apiError = null, isValidEntry) => {
  if (apiError != null) {
    return <span>{ErrorRegistry.getErrorMessage(apiError)}</span>;
  }

  if (!isValidEntry) {
    return <span>Invalid work order number</span>;
  }
};

class AlertWorkOrderForm extends Component {
  state = {
    error: null,
    isOpen: false,
    alertWorkOrder: {
      workOrderNumber: "",
      description: ""
    },
    isSubmitting: false,
    isValidEntry: true
  };

  handleInputChange = (inputName, inputValue) => {
    const alertWorkOrder = this.state.alertWorkOrder;
    alertWorkOrder[inputName] = inputValue;
    this.setState({ error: null, isValidEntry: true });

    if (
      inputName === "workOrderNumber" &&
      (isNaN(inputValue) || inputValue[0] === "0")
    ) {
      this.setState({ isValidEntry: false, error: null });
    }
    if (
      inputName === "workOrderNumber" &&
      !isNaN(inputValue) &&
      inputValue.length === 8
    ) {
      this.setState({ isValidEntry: true, error: null });
    }

    this.setState({ alertWorkOrder: alertWorkOrder });
  };

  handleSubmit = () => {
    if (!this.validate()) {
      return;
    }

    this.setState({ isSubmitting: true });

    const alertWorkOrder = this.state.alertWorkOrder;

    this.props
      .createAlertWorkOrder(
        alertWorkOrder.workOrderNumber,
        alertWorkOrder.description
      )
      .then(callback => {
        this.setState({ isSubmitting: false });
        this.forceUpdate();
        //this.props.onAlertWorkOrderSaved();
      })
      .catch(response => {
        this.setState({ error: response, isSubmitting: false });
      });
  };

  validate = () => {
    const alertWorkOrder = this.state.alertWorkOrder;

    if (
      !alertWorkOrder.workOrderNumber ||
      !alertWorkOrder.description ||
      alertWorkOrder.workOrderNumber.length < 8 ||
      isNaN(alertWorkOrder.workOrderNumber)
    ) {
      return false;
    }

    return true;
  };

  render() {
    return (
      <Card>
        <Grid cols={{ xs: 2, sm: 2, lg: 2, default: 1 }} gap="md">
          <GridItem colSpan={{ xs: 1, sm: 1, lg: 1, default: 1 }}>
            <h3>Work Orders</h3>
          </GridItem>
          <GridItem
            colSpan={{ xs: 1, sm: 1, lg: 1, default: 1 }}
            style={{ textAlign: 'right' }}
          >
            <ButtonGroup>
              <Button variant="secondary" onClick={() => this.setState({ isOpen: true })}>
                Add new work order
              </Button>
            </ButtonGroup>
          </GridItem>
        </Grid>
        <Modal
          onClose={() =>
            this.setState({
              isOpen: false,
              error: null,
              alertWorkOrder: {
                workOrderNumber: "",
                description: ""
              }
            })
          }
          isOpen={this.state.isOpen}
        >
          <Card>
            <h2 style={{ color: '#FF9900' }}>Add new work order</h2>

            <fieldset>
              <legend>Work order number</legend>
              <div>
                {renderError(this.state.error, this.state.isValidEntry) && (
                  <span style={{ color: '#cc0000', display: 'block', marginBottom: '0.5rem' }}>
                    {renderError(this.state.error, this.state.isValidEntry)}
                  </span>
                )}
                <Input
                  placeholder="Enter 8 digit work order number"
                  value={this.state.alertWorkOrder.workOrderNumber}
                  label="Work order number"
                  name="workOrderNumber"
                  maxLength={8}
                  onChange={e =>
                    this.handleInputChange(e.target.name, e.target.value)
                  }
                  disabled={this.state.isSubmitting}
                  status={renderError(this.state.error, this.state.isValidEntry) ? "error" : undefined}
                />
              </div>
            </fieldset>
            <TextArea
              placeholder="Enter description here"
              label="Description"
              value={this.state.alertWorkOrder.description}
              maxLength={1000}
              name="description"
              onChange={e =>
                this.handleInputChange(e.target.name, e.target.value)
              }
              disabled={this.state.isSubmitting}
            />
            <div style={{ marginTop: '1rem' }}>
              <LoadingWrapper isSubmitting={this.state.isSubmitting}>
                <Button
                  disabled={this.state.isSubmitting || !this.validate()}
                  onClick={() => this.handleSubmit()}
                >
                  Save
                </Button>
              </LoadingWrapper>
            </div>
          </Card>
        </Modal>
      </Card>
    );
  }
}

AlertWorkOrderForm.propTypes = {
  mapWorkOrdersForList: PropTypes.func,
  onAlertWorkOrderSaved: PropTypes.func,
  alertId: PropTypes.string.isRequired,
  onError: PropTypes.string
};

export default AlertWorkOrderForm;
